import { Question } from "shared/models/questions/question";
import { TranslatedText } from "shared/models/translated-text";

export class Jump {
  title: TranslatedText;
  _id: string; // is node id
  question: Question;
  dataType: string;

  constructor(_id: string, question: Question) {
    this.title = question.title;
    this._id = _id;
    this.question = question;
    this.dataType = 'jump';
  }
}




// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/interfaces/jump.ts